__turbopack_context__.v({
  "banner": "styles-module-scss-module__1_Khaa__banner",
});
